import React from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient'; // Adjust the import path as necessary

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: '#fff', // Adjust as per your color theme
  },
  giftCardList: {
    padding: '20px',
  },
  giftCard: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '15px',
    padding: '10px',
    backgroundColor: '#f9f9f9', // Light grey background for each gift card item
    borderRadius: '10px',
  },
  giftCardLogo: {
    width: '50px', // Set your desired logo size
    height: '50px',
    marginRight: '20px',
  },
  giftCardName: {
    flexGrow: 1,
    fontWeight: 'bold',
  },
  giftCardBalance: {
    fontWeight: 'bold',
  },
  navbar: {
    display: 'flex',
    justifyContent: 'space-around',
    position: 'fixed',
    bottom: '0',
    width: '100%',
    backgroundColor: '#333', // Dark background for the navbar
    color: 'white',
    padding: '10px 0',
  },
  signOutButton: {
    backgroundColor: '#f44336',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '1rem',
    // This ensures the button stays on the right even if the title is long
    marginLeft: 'auto',
  },
};

// Mock data for gift cards
const giftCards = [
  { id: 1, name: 'Starbucks', balance: '123.78', logo: 'starbucks.png' },
  { id: 2, name: 'Wal-Mart', balance: '3,253.32', logo: 'walmart.jpg' },
  { id: 3, name: 'HMart', balance: '234.47', logo: 'hmart.jpg' },
  { id: 4, name: 'Patagonia', balance: '71.84', logo: 'patagonia.png' },
];

const GiftCards = () => {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      navigate('/'); // Redirect to the home page or login
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div style={styles.container}>
        <h1 style={styles.title}>Gift Cards</h1>
        <button onClick={handleSignOut} style={styles.signOutButton}>
          Sign out
        </button>
      <div style={styles.giftCardList}>
        {giftCards.map(card => (
          <div key={card.id} style={styles.giftCard}>
            <img src={card.logo} alt={`${card.name} Logo`} style={styles.giftCardLogo} />
            <span style={styles.giftCardName}>{card.name}</span>
            <span style={styles.giftCardBalance}>{card.balance} USD</span>
          </div>
        ))}
      </div>
      <div style={styles.navbar}>
        <span>Home</span>
        <span>Wallet</span>
        <span>Send/Receive</span>
        <span>Exchange</span>
        <span>Settings</span>
      </div>
    </div>
  );
};

export default GiftCards;
